import GridOn from "@mui/icons-material/GridOn";
import { Button, Stack, Typography } from "@mui/material";

import { useSidePanelTabPrefs } from "components/PlotMap/hooks/useSidePanelTabPrefs";

interface GoToBoundsPromptProps {
  header: string;
  message: string;
}

const GoToBoundsPrompt: React.FC<GoToBoundsPromptProps> = ({
  header,
  message,
}) => {
  const { setTabPrefs } = useSidePanelTabPrefs();

  const handleGoToBounds = () => {
    setTabPrefs({ isOpen: true, tab: "bnd" });
  };

  return (
    <Stack spacing={1.5} sx={{ alignItems: "center", textAlign: "center" }}>
      <GridOn color="disabled" sx={{ fontSize: 48 }} />
      <Typography
        component="h3"
        sx={{ fontWeight: "bold" }}
        variant="subtitle1"
      >
        {header}
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 360 }} variant="body2">
        {message}
      </Typography>
      <Button
        aria-label="Go to bounds tab"
        onClick={handleGoToBounds}
        variant="contained"
      >
        Go To Bounds
      </Button>
    </Stack>
  );
};

export default GoToBoundsPrompt;
